<template>
  <div id="app">
    <div class="container-custom">
      <div class="block_bg"></div>
    </div>
    <router-view/>
    <Footer />
    <NotFound />
  </div>
</template>

<script>
import Footer from "@/components/Footer.vue";
import NotFound from '@/components/NotFound.vue'

export default {
  data() {
    return {
      info: ''
    }
  },
  components: {
    Footer,
    NotFound
  },
  beforeMount() {
    this.info = window.MY_CONFIG_EASYQ.info;
  }
}
</script>


<style>
/* .block_bg {
  background: linear-gradient(45deg,#fff 10%,#7d8533 50%,rgb(107, 119, 0) 100%) !important;
}
.footer .blockActive .block__title,
.footer .blockActive .fa,
.footer .block__item:hover .block__title,
.footer .block__item:hover .fa {
  color: #7d8533 !important;
}
.card .btn {
  background: #7d8533 !important;
}
.mapPopup__link {
  background: #7d8533 !important;
}
.card .btn:hover,
.mapPopup__link:hover {
  background: rgba(101, 119, 0, 0.623) !important;
}
.modal-inputSelect .activeItem .fa,
.modal-inputSelect .activeItem p {
  color: #7d8533 !important;
}
.modal-inputSelect .modal-btn__link {
  background: #7d8533 !important;
}
.modal-inputSelect .modal-btn__link:hover {
  background: rgba(101, 119, 0, 0.623) !important;
}
.vdp-datepicker__calendar .cell.selected {
  background: #7d8533 !important;
  color: #fff;
}
.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day:hover {
  border: 1px solid #7d8533 !important;
}
.card-modal .btn {
  background: #7d8533 !important;
}
.card-modal .btn:hover {
  background: rgba(101, 119, 0, 0.623) !important;
} */
</style>
